export default __webpack_public_path__ + "static/media/42-ClubMed.f5ca079d.jpg";